import { render, staticRenderFns } from "./HdsList.vue?vue&type=template&id=bb6b1674&scoped=true&"
import script from "./HdsList.vue?vue&type=script&lang=ts&"
export * from "./HdsList.vue?vue&type=script&lang=ts&"
import style0 from "./HdsList.vue?vue&type=style&index=0&id=bb6b1674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6b1674",
  null
  
)

export default component.exports